import React, { memo, useEffect } from "react";
import Navbar from "../Navbar";
import "./ViewCertificate.css";
import { useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import DownloadPage from "../DownloadPage";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Box, Button, ThemeProvider, createTheme } from "@mui/material";

function UpdateBill() {
  const navigate = useNavigate();
  const [billInput, setbillInput] = useState({
    party_code: "",
    amount:"",
    remarks:"",
    certificate_id:"",
    month_of_test:"",
    vertical_type:"",
    userId:"",
    cash_related:"",
    billing_party_code:""
  });

  const [loading, setLoading] = useState(true);
  const [productInput, setproduct] = useState([]);
  const [verticalInput, setverticalInput] = useState([]);
  const [itemDetails, setitemDetails] = useState([]);
  // console.log('data',verticalInput)

  const { id } = useParams();
  useEffect(() => {
    const product_id = id;
    axios.get(`/api/view_certificate/${product_id}`).then((res) => {
      if (res.data.status === 200) {
        // console.log(res.data.chalans);
        setproduct(res.data.chalans);
        setitemDetails(res.data.itemDetails);
        setverticalInput(res.data.chalanseqence);
      } else if (res.data.status === 404) {
        swal("Error", res.data.message, "error");
        navigate("/certificates/downloadcertificate");
      }
      setLoading(false);
    });
  }, [id, navigate]);

  const { palette } = createTheme();
  const { augmentColor } = palette;
  const createColor = (mainColor) =>
    augmentColor({ color: { main: mainColor } });
  const theme = createTheme({
    palette: {
      anger: createColor("#F40B27"),
      apple: createColor("#A38A00"),
      steelBlue: createColor("#5C76B7"),
      violet: createColor("#BC00A3"),
    },
    button: {
      // Here is where you can customise the button
      fontSize: 16,
      fontWeight: 1700,
    },
  });

  const handleInput = (e) => {
    e.persist();
    setproduct({ ...productInput, [e.target.name]: e.target.value });
    setbillInput({...billInput, [e.target.name]: e.target.value})
  };
  if (loading) {
    swal({
      title: "Loading",
      text: "Please Wait!!!",
      timer: 1000,
      buttons: false,
    }).then(
      function () {},
      // handling the promise rejection
      function (dismiss) {
        if (dismiss === "timer") {
          //console.log('I was closed by the timer')
        }
      }
    );
  }
 
 // ------------- view customer details -----------------------
  const [categorylist, setCategorylist] = useState([]);
  useEffect(() => {
    axios.get(`api/view-customer`).then((res) => {
    // axios.get(`https://cert.geekay.biz/backend/api/view-customer`).then((res) => {
      if (res.status === 200) {
        setCategorylist(res.data.customer);
      }
    });
  }, []);

// ------- Get bill details -----
  useEffect(() => {
    const product_id = id;
    axios.get(`api/view_bill/idlr/${product_id}`).then((res) => {
    console.log('billingDetails',res.data.billData)
    // axios.get(`https://cert.geekay.biz/backend/api/view-customer`).then((res) => {
      if (res.status === 200) {
        setbillInput(res.data.billData);
      }else if (res.data.status === 404) {
        swal("Error", res.data.message, "error");
        navigate("/certificates/downloadcertificate");
      }
    });
  }, []);

  const values = categorylist.map((item) => {
    return <option value={categorylist.acode}>{item.pcode}</option>;
  });

  const submitBill = (e) => {
    e.preventDefault();
    let certificate_id = productInput.id;
    let monthoftest = productInput.month_of_test;
    let userId = localStorage.getItem("auth_id");
    console.log(id);
    const data = {
      party_code: productInput.party_code,
        amount: billInput.amount,
        vertical_type:productInput.vertical_type,
        remarks:billInput.remarks,
        certificate_id:certificate_id,
        certificate_no:productInput.memo_no,
        cash_related:billInput.cash_related,
        billing_party_code:billInput.billing_party_code,
        month_of_test:monthoftest,
        userId:userId,
    }
    console.log(data,"ALi");

    axios.post(`/api/update_bill`,data).then(res =>{
      if(res.data.status === 200){
        swal("Success",res.data.message,"success");
        document.getElementById('BILL_FORM').reset();
        navigate('/certificates/downloadcertificate');
      }
      else if(res.data.status === 400){
        setbillInput({...billInput,error_list:res.data.errors});
      }
    });
  }




  const challanId = id;
  return (
    <div>
      <main>
        <Navbar />
        <div className="row" style={{ marginTop: 20, width: "97%" }}>
            {/* // <div className="col-sm-1"></div> */}
            <div className="col-sm-12" style={{ marginLeft: 40 }}>
              <div className="card">
                <div className="card-header">
                  <h4>
                    <b>Create Bill</b>
                  </h4>
                  </div>
                  <form onSubmit={submitBill}  id="BILL_FORM">
                  <div className="card-body">
                  <div className="row">
                  <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                    <label>Party Code</label>
                    <select id="billing_party_code" name="billing_party_code" value={billInput.billing_party_code} onChange={handleInput}  className="form-control" >
                        <option value={productInput.party_code}>{productInput.party_code}</option>
                        {/* <option value="Industrial-MZ">Industrial-MZ</option>
                        <option value="Industrial-MA">Industrial-MA</option>
                        <option value="IDLR">IDLR</option> */}
                        {values}
                    </select>
                </div>
                <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                    <label>Cash Related</label>
                    <select id="cash_related" name="cash_related"  onChange={handleInput} value={billInput.cash_related}  className="form-control" >
                        <option value="">Cash Related</option>
                        <option value="CASH">CASH</option>
                        <option value="CASH REC">CASH REC</option>
                        <option value="CASH BAL">CASH BAL</option>
                        <option value="NO BILL">NO BILL</option>
                    </select>
                </div>
                <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                    <label>Amount</label>
                    <input type="Input" id="amount" onChange={handleInput} value={billInput.amount} className="form-control" name="amount"></input>
                    
                </div>
                <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                    <label>Remark</label>
                    <input type="Input" id="remarks" onChange={handleInput} value={billInput.remarks} className="form-control" name="remarks"></input>
                </div>
                <ThemeProvider theme={theme}>
            <Box
             marginTop={1}
             display="flex"
             padding={3}
             borderRadius={5}
             alignItems="center"
             justifyContent={"center"}
             >
             {/*<ThemeProvider theme={theme}>*/}
              <Button
                style={{
                  maxWidth: "200px",
                  maxHeight: "100px",
                  minWidth: "50px",
                  minHeight: "30px",
                }}
                color="apple"
                type="submit"
                variant="contained"
              >
                Submit
              </Button>
            </Box>
          </ThemeProvider>
                </div>
                </div>
                </form>
              </div>
            
            </div>
        </div>
        {/* <div className="m-1 border border-dark p-5"> */}
        <div className="maindiv">
          <section>
            <header className="headerdiv">
              <p className="heading">
                <b>Original</b>
              </p>
              <h6 className="topheader">
                <b>FORM V</b>
              </h6>
              <p className="top">
                <b>Prescribed by the Government of India under</b>
              </p>
              <h6 className="top">
                <b>
                  DOCK WORKERS (SAFETY,HEALTH AND WELFARE) REGULATIONS, 1990
                </b>
              </h6>
              <p className="top">
                <b>(See Regulations 47(1) and 51(2))</b>
              </p>
              <p className="top">
                <b>
                  Certificate of Initial & Periodical Test & Examination of
                  Loose Gear
                </b>
              </p>
            </header>
          </section>

          <section>
            <div className="mainbox1">
              <div className="boxes1">
                <p className="heading">
                  <b>Test Certificate No:</b>&nbsp;&nbsp;&nbsp;&nbsp;
                  {productInput.memo_no}
                </p>
                <p className="heading">
                  <b>(a) In case of Dock, wharf of Quay</b>
                </p>
                <p className="rightside">
                  <b>Name of dock, wharf of Quay</b>
                </p>
                <p className="rightside">
                  <b>where Lifting</b>
                </p>
                <p className="rightside">
                  <b>Appliances are fitted :</b>
                </p>
              </div>
              <div className="boxes2">
                <p className="heading">
                  <b>(b) In case of Ship -</b>
                </p>
                <p className="leftside">
                  <b>Name of the Ship :</b>&nbsp;&nbsp;&nbsp;&nbsp;
                  {productInput.ship_name}
                </p>
                <p className="leftside">
                  <b>Official Number :</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {productInput.official_number}
                </p>
                <p className="leftside">
                  <b>Call Sign :</b>
                </p>
                <p className="leftside">
                  <b>Port of Registry :</b>
                </p>
                <p className="leftside">
                  <b>Name of Owner :</b>
                </p>
              </div>
            </div>
          </section>

          <section>
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th className="heading" scope="col">
                    Distinguishing Number or mark
                  </th>
                  <th className="heading" scope="col">
                    Description Dimension and material of gear/device
                  </th>
                  <th className="heading" scope="col">
                    Number tested
                  </th>
                  <th className="heading" scope="col">
                    Date of test
                  </th>
                  <th className="heading" scope="col">
                    Test load applied
                  </th>
                  <th className="heading" scope="col">
                    Safe working load (SWL)
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr font-size="1px" height="5px">
                  <td height="5px"></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td className="heading" font-size="1px">
                    (Tonnes)
                  </td>
                  <td className="heading">(Tonnes)</td>
                </tr>
                <tr></tr>
                <tr>
                  {/* <td height="300px"></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td> */}
                  <td height="450px">
                    {itemDetails.map((post) => {
                      const lines = post.descriptive.split("\n");
                      const numLines = lines.length;
                      if (numLines > 4 && numLines < 8) {
                        return (
                          <div style={{ minHeight: "200px" }} key={post.pcode}>
                            {post.distin}
                            <br />
                          </div>
                        );
                      } else if (numLines > 8 && numLines < 13) {
                        return (
                          <div style={{ minHeight: "230px" }} key={post.pcode}>
                            {post.distin}
                            <br />
                          </div>
                        );
                      } else {
                        return (
                          <div style={{ minHeight: "130px" }} key={post.pcode}>
                            {post.distin}
                            <br />
                          </div>
                        );
                      }
                    })}
                  </td>
                  {/* <td height="450px">{itemDetails.map((post)=>{
                    const lines = post.descriptive.split('\n');
                    const numLines = lines.length;
                    if (numLines>4 && numLines<8) {
                      return(
                        <div style={{minHeight:"200px"}}  key={post.pcode}>{post.sn}<br /></div>);
                    } 
                    else if (numLines > 8 && numLines < 13) {
                       return(
                        <div style={{ minHeight:"230px" }}  key={post.pcode}>{post.sn}<br /></div>);
                    } else {
                      return(
                        <div style={{ minHeight:"130px" }}  key={post.pcode}>{post.sn}<br /></div>);
                    }
                  })}</td> */}
                  <td height="450px">
                    {itemDetails.map((post) => {
                      const lines = post.descriptive.split("\n");
                      const numLines = lines.length;
                      const desc = post.descriptive;
                      if (numLines > 4 && numLines < 8) {
                        return (
                          //<div style={{minHeight:"200px"}}  key={post.pcode}>{post.descriptive}<br /></div>);
                          <div style={{ minHeight: "200px" }} key={post.pcode}>
                            {lines.map((post) => {
                              return (
                                <div>
                                  {post}
                                  <br />
                                </div>
                              );
                            })}
                            <br />
                          </div>
                        );
                      } else if (numLines > 8 && numLines < 13) {
                        return (
                          <div style={{ minHeight: "230px" }} key={post.pcode}>
                            {lines.map((post) => {
                              return (
                                <div>
                                  {post}
                                  <br />
                                </div>
                              );
                            })}
                            <br />
                          </div>
                        );
                      } else {
                        return (
                          <div style={{ minHeight: "130px" }} key={post.pcode}>
                            {lines.map((post) => {
                              return (
                                <div>
                                  {post}
                                  <br />
                                </div>
                              );
                            })}
                            <br />
                          </div>
                        );
                      }
                    })}
                  </td>
                  <td height="450px">
                    {itemDetails.map((post) => {
                      const lines = post.descriptive.split("\n");
                      const numLines = lines.length;
                      if (numLines > 4 && numLines < 8) {
                        return (
                          <div style={{ minHeight: "200px" }} key={post.pcode}>
                            {post.test}
                            <br />
                          </div>
                        );
                      } else if (numLines > 8 && numLines < 13) {
                        return (
                          <div style={{ minHeight: "230px" }} key={post.pcode}>
                            {post.test}
                            <br />
                          </div>
                        );
                      } else {
                        return (
                          <div style={{ minHeight: "130px" }} key={post.pcode}>
                            {post.test}
                            <br />
                          </div>
                        );
                      }
                    })}
                  </td>
                  <td>{productInput.date}</td>
                  <td height="450px">
                    {itemDetails.map((post) => {
                      const lines = post.descriptive.split("\n");
                      const numLines = lines.length;

                      if (numLines > 4 && numLines < 8) {
                        return (
                          <div style={{ minHeight: "200px" }} key={post.pcode}>
                            {post.pltonns}
                            <br />
                          </div>
                        );
                      } else if (numLines > 8 && numLines < 13) {
                        return (
                          <div style={{ minHeight: "230px" }} key={post.pcode}>
                            {post.pltonns}
                            <br />
                          </div>
                        );
                      } else {
                        return (
                          <div style={{ minHeight: "130px" }} key={post.pcode}>
                            {post.pltonns}
                            <br />
                          </div>
                        );
                      }
                    })}
                  </td>
                  <td height="450px">
                    {itemDetails.map((post) => {
                      const lines = post.descriptive.split("\n");
                      const numLines = lines.length;

                      if (numLines > 4 && numLines < 8) {
                        return (
                          <div style={{ minHeight: "200px" }} key={post.pcode}>
                            {post.swltonns}<br/>{post.swltonns2}
                            <br />
                          </div>
                        );
                      } else if (numLines > 8 && numLines < 13) {
                        return (
                          <div style={{ minHeight: "230px" }} key={post.pcode}>
                            {post.swltonns}<br/>{post.swltonns2}
                            <br />
                          </div>
                        );
                      } else {
                        return (
                          <div style={{ minHeight: "130px" }} key={post.pcode}>
                            {post.swltonns}<br/>{post.swltonns2}
                            <br />
                          </div>
                        );
                      }
                    })}
                  </td>
                </tr>
              </tbody>
            </table>
          </section>

          <section>
            <div>
              <p className="heading">
                <b>7.Name and address of manufacturer or supplier :</b>{" "}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                {productInput.party_name}
              </p>
              <p className="heading">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                {productInput.address}
              </p>
            </div>
            <div>
              <p className="heading">
                <b>8.Initial test and examination certificate no. and date :</b>
              </p>
              <p className="rightside">
                <b>(only in case of periodical test and examination)</b>
              </p>
            </div>
            <div>
              <p className="heading">
                <b>
                  9.Name and address of public service, association, :
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;GEE
                  KAY INDUSTRIES (INDIA)
                  <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;17A,
                  Sitafal Wadi, Mount Road, Mazgaon,
                  <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Mumbai-400
                  010
                </b>
              </p>
              <p className="rightside">
                <b>company or firm or testing establishment making</b>
              </p>
              <p className="rightside">
                <b>the test and examination</b>
              </p>
            </div>
            <div>
              <p className="heading">
                <b>
                  10.Name and position of the Competent person in :
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;MUSTAFA
                  ZOEB MAHIMWALA <br />{" "}
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(Manager)
                </b>
              </p>
              <p className="rightside">
                <b>public service, association, company or firm or</b>
              </p>
              <p className="rightside">
                <b>testing establishment.</b>
              </p>
            </div>
          </section>

          <section>
            <div>
              <p className="heading">
                <b>
                  I certify that on the 16th day of June 2012, the above gear
                  was tested and examined in the manner set forth overleaf;
                </b>
              </p>
              <p className="rightside">
                <b>
                  that the examination showed the said gear/device withstood the
                  test load without injury or deformation; and that the safe
                  working load
                </b>
              </p>
              <p className="rightside">
                <b>of the said gear/device as shown in column 6.</b>
              </p>
            </div>
          </section>

          <section>
            <div>
              <p className="downheading">
                <b>Signature of the Competent person</b>
              </p>
              <p className="rightside">
                <b>(See Note 2)</b>
              </p>
            </div>
          </section>

          <section>
            <div className="mainbox1">
              <div className="boxes6">
                <p className="heading">
                  <b>Registration / Authority number of the Competent Person</b>
                </p>
              </div>
              <div className="boxes7">
                <p className="heading">
                  <b>Seal</b>
                </p>
              </div>
              <div className="boxes8">
                <p className="heading">
                  <b>Date:</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{productInput.date}
                </p>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  )
}

export default UpdateBill